import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_ESUS,
    useChartsData
} from '../../../Common/Filters/useChartsData';

export const RegistersChartsDataContext = createContext();

const RegistersChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_ESUS.REGISTERS_REGISTERS,
            url: 'governanceroom/esus/registers/registers'
        },
        {
            year: filters.ano.value,
            month: filters.competencia.map((competencia) => competencia.value),
            register_type: filters.register_type_registers.value,
            city: filters.cidade?.governance_room_geo_city_id,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  newRegisters: data?.indicators?.newRegisters ?? 0,
                  updates: data?.indicators?.updates ?? 0,
                  refusal: data?.indicators?.refusal ?? 0
              },
              annualEvolutionRegisters: data?.annualEvolutionRegisters ?? [],
              monthlyEvolutionRegisters: data?.monthlyEvolutionRegisters ?? []
          }
        : {
              indicators: {
                  newRegisters: 0,
                  updates: 0,
                  refusal: 0
              },
              annualEvolutionRegisters: [],
              monthlyEvolutionRegisters: []
          };

    return (
        <RegistersChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </RegistersChartsDataContext.Provider>
    );
};

export default RegistersChartsDataProvider;
